import React, {useState} from 'react';
import UploadedImagePreview from './UploadedImagePreview'

type OnOperationComplete = (result: string) => void;

interface OperationComponentProps {
    onPredictionComplete: OnOperationComplete;
}

function UploadForm({ onPredictionComplete } : OperationComponentProps) {
    const [preview, setPreview] = useState( "");
    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        function getBase64(file: File): Promise<string> {
            const reader = new FileReader()
            return new Promise(resolve => {
                reader.onload = ev => {
                    // @ts-ignore
                    resolve(ev.target.result)
                }
                reader.readAsDataURL(file)
            })
        }

        event.preventDefault();
        const fileInput = document.getElementById('file') as HTMLInputElement;

        // @ts-ignore
        const file = fileInput.files[0];
        const base64String: string = await getBase64(file);

        setPreview(base64String);

        const jsonData = JSON.stringify(
            { "data": [
                    base64String
                ]}
        );

        const response = await fetch('https://rafadecastro-strato-or-tele.hf.space/api/predict', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: jsonData,
        });

        if (!response.ok) {
            throw new Error('Prediction request failed');
        }

        const data = await response.json();
        onPredictionComplete(data.data[0].label);
    };

    return (
        <form onChange={handleSubmit}>
            <div className={"mx-auto flex flex-row justify-center"}>
                <div className={"flex-1/2"}>
                    <div><label htmlFor="file">Upload a picture with a guitar in it: </label></div>
                    <div><input type="file" id="file" name="file" /></div>
                </div>
                <div className={"flex-1/2"}>
                    <UploadedImagePreview preview={preview}/>
                </div>
            </div>
        </form>
    );
}

export default UploadForm;
